function setupV10Product(section) {
  if (section.dataset.dbV10GalleryInitialized !== 'true') {
    section.dataset.dbV10GalleryInitialized = 'true';
    const slides = section.querySelectorAll('[data-db-v10-slide]');
    const thumbnails = section.querySelectorAll('[data-db-v10-thumb]');

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const selectedIndex = Number(thumbnail.dataset.index);
        slides.forEach((slide, index) => {
          slide.hidden = index !== selectedIndex;
        });
        thumbnails.forEach((item, index) => {
          item.classList.toggle('is-active', index === selectedIndex);
          item.setAttribute('aria-pressed', String(index === selectedIndex));
        });
      });
    });
  }

  const trigger = section.querySelector('[data-pc2-open]');
  const overlay = trigger && document.getElementById(`pc2-overlay-${trigger.dataset.pc2Open}`);
  const body = overlay && overlay.querySelector('.pc2-body');
  if (!body || overlay.dataset.dbV10Enhanced === 'true') return;

  overlay.dataset.dbV10Enhanced = 'true';
  overlay.classList.add('pc2-overlay--v10');
  const unavailableMaintenance = body.querySelector('[data-value="diy-maintenance"][data-unavailable="true"]');
  if (unavailableMaintenance) unavailableMaintenance.closest('.pc2-section').remove();
  const steps = Array.from(body.querySelectorAll(':scope > .pc2-section'));
  if (steps.length < 2) return;

  const extras = document.createElement('details');
  extras.className = 'pc2-extras';
  const extrasSummary = document.createElement('summary');
  extrasSummary.textContent = section.dataset.extrasHeading || 'Extra accessoires (optioneel)';
  extras.append(extrasSummary);
  steps[0].after(extras);

  steps.slice(1).forEach((step, index) => {
    const heading = step.querySelector(':scope > h3');
    let title = heading ? heading.textContent.trim().replace(/^\d+\.\s*/, '') : 'Extra optie';
    if (title === 'Customize jouw fatbike / skinnybike') title = 'Styling en accessoires';
    const label = `${index + 2}. ${title}`;
    if (heading) heading.textContent = label;
    step.setAttribute('aria-label', label);
    extras.append(step);
  });
}

document.querySelectorAll('[data-db-v10-section]').forEach(setupV10Product);
document.addEventListener('shopify:section:load', (event) => {
  const sections = event.target.matches('[data-db-v10-section]')
    ? [event.target]
    : event.target.querySelectorAll('[data-db-v10-section]');
  sections.forEach(setupV10Product);
});
